import { render, staticRenderFns } from "./bulletineditor.vue?vue&type=template&id=1c676f4a&lang=pug"
import script from "./bulletineditor.vue?vue&type=script&lang=js"
export * from "./bulletineditor.vue?vue&type=script&lang=js"
import style0 from "./bulletineditor.vue?vue&type=style&index=0&id=1c676f4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports